export const convertToDate = (date: string): string =>
  new Date(date).toLocaleDateString("dk").replace(/\//g, "-");
export const convertToCurency = (number: number, separator = ","): string =>
  (number ?? 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
export const convertToQueryString = (params: any) =>
  Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
